import * as actionTypes from './action-types'

export const getProcurementInfo = locale => ({
  type: actionTypes.PROCUREMENT,
  payload: { locale },
})
